function isStandaloneDisplayMode() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;

  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: window-controls-overlay)').matches
  );
}

export function getAppSurface() {
  if (typeof navigator !== 'undefined' && navigator.userAgent.includes('Electron')) return 'electron';
  if ((typeof navigator !== 'undefined' && navigator.standalone === true) || isStandaloneDisplayMode()) {
    return 'pwa';
  }
  return 'browser';
}

export function track(eventName, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
}

export function trackButtonClick(buttonName, params = {}) {
  track('button_click', {
    button_name: buttonName,
    ...params,
  });
}

const trackedPageEvents = new Set();

export function trackOncePerPage(eventName, params = {}) {
  if (trackedPageEvents.has(eventName)) return;
  trackedPageEvents.add(eventName);
  track(eventName, params);
}

